import type { FilterSpecification } from 'mapbox-gl'
import { type Dayjs, dayjs } from '../../dayjs.ts'
import { env } from '../../env.ts'
import { LRT_ANIMATED_INTERVAL, LTZ_DETAILED_MIN_ZOOM } from './legendConstants.tsx'

const LTZ_RUN_INTERVAL_MS = 120_000
const LTZ_RUN_DELAY_MS = 60_000
const LTZ_PLAYING_INTERVAL_MS = LRT_ANIMATED_INTERVAL * 60_000
const LTZ_V1_HISTORY_HOURS = 3
const LTZ_HORIZONS_MINUTES = [10, 20, 30, 40, 50, 60]

const ltzV1 = {
	polygon: { url: env.LTZ_POLYGON_LAYER, sourceLayer: 'ltz_polygon_view', minZoom: LTZ_DETAILED_MIN_ZOOM, filter: undefined },
	centroid: { url: env.LTZ_CENTROID_LAYER, sourceLayer: 'ltz_centroid_view' },
	velocity: { url: env.LTZ_VELOCITY_LAYER, sourceLayer: 'ltz_velocity_view', minZoom: LTZ_DETAILED_MIN_ZOOM },
	horizonAttribute: 'max_horizon_minutes',
	historyHours: LTZ_V1_HISTORY_HOURS,
} as const

const ltzV2 = {
	polygon: {
		url: env.LTZ_V2_POLYGON_LAYER,
		sourceLayer: 'vw_ltz_polygon',
		minZoom: LTZ_DETAILED_MIN_ZOOM,
		filter: ['in', ['get', 'horizon_min'], ['literal', LTZ_HORIZONS_MINUTES]] satisfies FilterSpecification,
	},
	centroid: { url: env.LTZ_V2_CENTROID_LAYER, sourceLayer: 'vw_ltz_centroid' },
	velocity: { url: env.LTZ_V2_VELOCITY_LAYER, sourceLayer: 'vw_ltz_vector', minZoom: LTZ_DETAILED_MIN_ZOOM },
	horizonAttribute: 'horizon_min',
	historyHours: undefined,
} as const

export const ltzLayers = (ltzAlertsV2: boolean | undefined) => (ltzAlertsV2 ? ltzV2 : ltzV1)

export const isLtzShownAt = (date: Dayjs, now: Dayjs, ltzAlertsV2: boolean | undefined) => {
	const { historyHours } = ltzLayers(ltzAlertsV2)
	if (date.isAfter(now)) return false
	return historyHours === undefined || !date.isBefore(now.subtract(historyHours, 'hour'))
}

export const ltzRunTime = (date: Dayjs, isPlaying = false) => {
	if (isPlaying) return dayjs(Math.floor(date.valueOf() / LTZ_PLAYING_INTERVAL_MS) * LTZ_PLAYING_INTERVAL_MS)
	return dayjs(Math.floor((date.valueOf() - LTZ_RUN_DELAY_MS) / LTZ_RUN_INTERVAL_MS) * LTZ_RUN_INTERVAL_MS)
}
